export const defaultConfigColunas = [
  { nome: "idProcesso", exibir: true },
  { nome: "placa", exibir: true },
  { nome: "chassi", exibir: false },
  { nome: "renavam", exibir: false },
  { nome: "uf", exibir: true },
  { nome: "empresa", exibir: true },
  { nome: "cnpj", exibir: true },
  { nome: "divisao", exibir: false },
  { nome: "centroCusto", exibir: false },
  { nome: "situacao", exibir: true },
  { nome: "solicitante", exibir: false },
  { nome: "data", exibir: true },
  { nome: "statusSolicitacao", exibir: true },
  { nome: "usuarioResponsavel", exibir: true },
];
